import { Injectable } from '@angular/core'

import { TranslateService } from '@ngx-translate/core'

type MessageData = {
  summary: string
  detail: string
}
type confirmData = {
  header: string
  message: string
}

@Injectable({
  providedIn: 'root',
})
export class TranslateMessagesService {
  entityName: string = ''
  constructor(private translate: TranslateService) {}
  init(entityName: string) {
    this.entityName = entityName
  }
  create(entityName: string) {
    const translate = this.translate
    const methods = {
      message(codeMessage: string, data: unknown = {}): MessageData {
        const entityData: Record<string, unknown> = 'object' == typeof data && data != null ? (data as Record<string, unknown>) : { name: data }

        if (Object.keys(entityData).length) {
          if (entityData['name'] === undefined || entityData['name'] === '') {
            if ('full_name' in entityData) {
              entityData['name'] = entityData['full_name']
            } else if (entityData['title']) {
              entityData['name'] = entityData['title']
            }
          }
        }
        return {
          summary: translate.instant(`SYSTEM.MESSAGES.${codeMessage}.TITLE`, {
            entityName: translate.instant(`SYSTEM.ENTITY_NAMES.${entityName}`),
            entityData: entityData,
          }),
          detail: translate.instant(`SYSTEM.MESSAGES.${codeMessage}.MESSAGE`, {
            entityName: translate.instant(`SYSTEM.ENTITY_NAMES.${entityName}`),
            entityData: entityData,
          }),
        }
      },
      system(str: string) {
        return translate.instant(`SYSTEM.${str}`, {
          entityName: translate.instant(`SYSTEM.ENTITY_NAMES.${entityName}`),
        })
      },
      confirm(codeMessage: string, data: unknown = {}): confirmData {
        const entityData: Record<string, unknown> = 'object' == typeof data && data != null ? (data as Record<string, unknown>) : { name: '' }
        if (Object.keys(entityData).length) {
          if (entityData['name'] === undefined) {
            if ('full_name' in entityData) {
              entityData['name'] = entityData['full_name']
            }
          }
        }
        return {
          header: translate.instant(`SYSTEM.MESSAGES.${codeMessage}.TITLE`, {
            entityName: translate.instant(`SYSTEM.ENTITY_NAMES.${entityName}`),
            entityData: entityData,
          }),
          message: translate.instant(`SYSTEM.MESSAGES.${codeMessage}.MESSAGE`, {
            entityName: translate.instant(`SYSTEM.ENTITY_NAMES.${entityName}`),
            entityData: entityData,
          }),
        }
      },
    }
    return methods
  }
}
